import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // ✅ tailwind 포함된 CSS
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
